import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faSearch, IconDefinition } from '@fortawesome/pro-solid-svg-icons';

interface ErrorStateProps {
  title: string;
  message: string;
  height?: string;
  icon?: IconDefinition;
}

const StrategyErrorState: React.FC<ErrorStateProps> = ({
  title,
  message,
  height = 'h-full',
  icon = faSearch,
}) => {
  return (
    <div
      className={`flex items-center justify-center w-full ${height} bg-slate-100`}
    >
      <div className="flex-1 flex flex-col items-center justify-center p-8 text-center">
        <div className="w-20 h-20 bg-gradient-to-br from-red-50 to-rose-100 rounded-2xl flex items-center justify-center mb-6 shadow-sm">
          <Icon icon={icon} className="text-red-500" size="xl" />
        </div>
        <h3 className="text-xl font-semibold text-slate-800 mb-2">{title}</h3>
        <p className="text-sm text-slate-500 leading-relaxed">{message}</p>
      </div>
    </div>
  );
};

export default StrategyErrorState;
